//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import axios from 'axios';
  import wxlogin from 'vue-wxlogin';
  import crypto from '@/common/js/crypto.js';
  export default {
    data() {
      return {
        select_list: [],
        tab_bar: [],
        tabword: 'index',
        selected_id: 'news', //
        key_word: '', //查询词语
        infoflag: false, //显示个人中心、退出登录等
        islogin: false, //登录按钮点击
        phoneflag: false,
        login_info: false, //是否已经登录
        login_show: false, //显示登录弹框
        phone: '', //手机号（会员号）
        password: '', //密码
        aamsg:'',
        aa:'',
        tucode:'',//验证码
        tuCodeUrl:'',//验证码url
      }
    },
    created() {
      this.phoneflag = JSON.parse(localStorage.getItem('phoneflag'))
      if (this.phoneflag == true) {
        this.login_show = true;
        localStorage.removeItem("phoneflag")
      }
      if (localStorage.getItem('TOKEN')) {
        this.$axios.post(`/v8/PC_Member/pc_member_info`).then(res => {
          if (res.data.code == 200) {
            this.info = res.data.data;
            this.login_info = true;
          }
        })
      }
    },
    mounted() {
      this.getTabBar();
      let tabword = this.$route.query.tabword;
      if (!tabword) {
        tabword = "index";
      }
      this.tabword = tabword;
    this.changetuCode();
    },
    methods: {
      // 修改
      changetuCode:function(){
         this.tuCodeUrl = "/v1/catcha/getCode?time="+new Date();
      },
      goIndex: function() {
        this.$router.push("/index")
      },
      goVideo: function() {
        this.$router.push("/zhibos?tabword=video");
      },
      // 获取导航列表
      getTabBar: function() {
        var that = this;
        this.$axios.post('v8/Index/getTabBar', {}).then(res => {
          if (res.data.code == 0) {
            that.tab_bar = res.data.data;
          }
        })
      },
      // 查询数据
      searchBtn: function() {
        var selected_id = this.selected_id;
        var key_work = this.key_word;
        if (selected_id == "news") {
          //新闻
          this.$router.push("/searchnews?tabword=SEARCH&key_word=" + key_work);
        } else if (selected_id == "video") {
          //视频
          this.$router.push("/zhibos?tabword=VIDEO&key_word=" + key_work);
        }
      },
      // goLinke:function (jion=1,link="#"){
      //   if(jion==1){ //外联
      //       window.open(link)
      //   }else{
      //     this.$router.push(link)
      //   }
      // },
      goNewsType: function(tabword = "") {
        // if (tabword == "VIDEO") {
        //   this.$router.push("/zhibos?tabword=" + tabword);
        // } else {
          this.$router.push("/newsType?tabword=" + tabword);
        // }
      },
      getUrl() {
        let tabword = this.$route.query.tabword;
        // console.log(tabword);
        if (!tabword) {
          tabword = "index";
        }
        this.tabword = tabword;
      },
      infotitle() {
        this.infoflag = !this.infoflag
      },
     toPage(router){
       this.$router.push(router)
     },
      // 退出登录
      gotoup() {
        this.infoflag = false
        this.$axios.post(`/v1/login/outLogin`).then(res => {
          if (res.data.code == 200) {
            this.$tips(res.data.msg)
            localStorage.removeItem("TOKEN");
            this.$router.push('index')
            this.login_info = false;
          } else {
            this.$tips(res.data.msg)
          }
        })
      },
      //登录
      denglu() {
        if (this.islogin == true) {
          return false;
        }
        this.islogin = true;
        // 密码前后附加字符 jkg 2021.4.11
        // let a = this.password.slice(0, 2)
        // let b = this.password.slice(2, this.password.length)
        // let psw = "a#1w" + a + "#" + b + "s8$w";
        var psw = crypto.encrypt(this.password);
        let type = 5;

        this.$axios.post(`/v1/login/member_login`, {
          phone: this.phone,
          password: psw,
          type: type,
          captch_code:this.tucode,
        }).then(res => {
          this.islogin = false;
          if (res.data.code == 200) {
            this.$tips(res.data.msg)
            localStorage.setItem("TOKEN", res.data.data.info.token);
            localStorage.setItem("member_id", res.data.data.info.member_id);
            localStorage.setItem("idcard", res.data.data.info.idcard); //zhuqimin
            //alert("这是从后台调取的用户是否是党员的判断"+res.data.data.info.isDangyuan)
            this.login_show = false;
            this.phoneflag = false;
            localStorage.removeItem('phoneflag')
            if (localStorage.getItem("beforeLoginUrl")) {
              this.$router.push(localStorage.getItem("beforeLoginUrl"));
              localStorage.removeItem("beforeLoginUrl")
              return;
            }
            this.$axios.post(`/v8/PC_Member/pc_member_info`).then(res => {
              if (res.data.code == 200) {
                this.info = res.data.data;
                this.login_info = true;
              }
            })
          }else{
            this.aamsg=res.data.msg;
            this.aa=true;
          }
        })
      },
      //点击登录按钮
      click_login: function() {
        this.login_show = true;
      },
      // 关闭登录弹框
      closeLogin(){
        this.infoflag=false; //显示个人中心、退出登录等
        this.islogin=false; //登录按钮点击
        this.phoneflag= false;
        this.login_info=false; //是否已经登录
        this.login_show=false; //显示登录弹框
        localStorage.removeItem('phoneflag')
      },
    },
    watch: {
      '$route': 'getUrl' // 监听路由变化
    },
    components: {
      'v-header': "header"
    },
  }



// WEBPACK FOOTER //
// ./src/components/common/header.vue